import React, { useState, useEffect } from "react";
import "./popup.css";

export default function Popup() {
    const [open, setOpen] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);

        const response = await fetch("https://formspree.io/f/xpqegjbl", {
            method: "POST",
            body: formData,
            headers: {
                Accept: "application/json",
            },
        });

        if (response.ok) {
            alert("Message sent successfully!");
            setOpen(false);
            e.target.reset();
        } else {
            alert("Something went wrong!");
        }
    };
    useEffect(() => {
        setTimeout(() => {
            setOpen(true);
        }, 1000);
    }, []);

    const closePopup = () => {
        setOpen(false);
    };

    if (!open) return null;

    return (
        <div className="popup-overlay" id="popup">
            <div className="popup-box">

                <button className="close-btn" onClick={closePopup}>✕</button>

                <h2>Schedule Site Visit</h2>
                <p>Fill the form and our team will contact you shortly.</p>

                <form onSubmit={handleSubmit}>

                    <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        required
                    />
                    <input
                        type="text"
                        name="phone"
                        placeholder="Phone"
                    />

                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        required
                    />



                    {/* <textarea
                        name="message"
                        placeholder="Message"
                        rows="4"
                        required
                    />
                    */}

                    <button type="submit">Send</button> 

                </form>

            </div>
        </div>
    );
}